import React from 'react';
import './layout.css';
import {PageHeader, PageSection} from './PageSection';
import NavigationSection from './NavigationSection';
import PageControls from './PageControls';
import {
  Container,
  Row,
  Col 
} from 'reactstrap';

// Presentational component to display the main page body.
//  Passes props to SidebarSection and PageSection. 
//   (So might be a candidate for refactoring using a container component to give the children access to the data)
//
function Body(props) {
  console.log("rendering Body, with props: ", props );
  return(
    <Container className="instruct-main-section" fluid='true'>
      <Row style={{height: '100%'}}>
        {props.sidebarComponent && <NavigationSection contentComponent={props.sidebarComponent} />}
        <Col xs={9} lg={10} className='instruct-content-section' style={{height: '100%'}} role="main">
          <Row style={{ height: '90%' }}>
            <PageSection contentComponent={props.contentComponent}/> 
          </Row>
          <Row style={{ height: '10%'}}>
            <div style={{height: '100%'}}>
              <PageControls contentComponent={props.controlsComponent}/>
            </div>
          </Row>
        </Col>     
      </Row>
    </Container>
  );
}
 
export default Body;
